import { render } from "./submenu-popup.vue?vue&type=template&id=8f0d60f0"
import script from "./submenu-popup.vue?vue&type=script&lang=js"
export * from "./submenu-popup.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Cater-Frontend\\cater\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__